import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dd6d2b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-a-practice-areas" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-3" }, "Practice Areas", -1))

export function render(_ctx, _cache) {
  const _component_AllocationPercentile = _resolveComponent("AllocationPercentile")
  const _component_AllocationPercentileV2 = _resolveComponent("AllocationPercentileV2")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent && !_ctx.errorLoadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", {
            class: _normalizeClass(["questions-main", _ctx.validForm() ? 'answered' : ''])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formPartAData.practiceAreas.atcsMainQuestions, (q, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (q.atcsQuestionTypeId==_ctx.QuestionType.AreaOfLaw)
                  ? (_openBlock(), _createBlock(_component_AllocationPercentile, {
                      key: 0,
                      question: _ctx.formPartAData.practiceAreas.atcsMainQuestions[i],
                      "onUpdate:question": $event => ((_ctx.formPartAData.practiceAreas.atcsMainQuestions[i]) = $event),
                      onValidForm: $event => (_ctx.validationForm(i, $event))
                    }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                  : _createCommentVNode("", true),
                (q.atcsQuestionTypeId==_ctx.QuestionType.AreaOfLawsV2)
                  ? (_openBlock(), _createBlock(_component_AllocationPercentileV2, {
                      key: 1,
                      question: _ctx.formPartAData.practiceAreas.atcsMainQuestions[i],
                      "onUpdate:question": $event => ((_ctx.formPartAData.practiceAreas.atcsMainQuestions[i]) = $event),
                      onValidForm: $event => (_ctx.validationForm(i, $event))
                    }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ], 2)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}